import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { IGiftcardTrackingData } from './models/IGiftcardTrackingData'
import { getGiftcardTrackingDetails } from './utils'

export function giftcardAddToCart() {
  try {
    const metrics = getMetrics()
    metrics.api.track(
      EventTypes.GIFTCARD_ADD_TO_CART,
      getGiftcardTrackingDetails(),
    )
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

export function FacebookGiftcardAddToCart(data: IGiftcardTrackingData): any {
  return {
    value: data.total_value,
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.trip_type,
    content_category: data.category,
    country: data.country,
  }
}

export function GoogleGiftcardAddToCart(data: IGiftcardTrackingData): any {
  return {
    currency: data.currency,
    items: [
      {
        id: data.trip_id,
        name: data.trip_type,
        category: data.category,
        price: data.total_value,
        quantity: 1,
        dimension17: data.country,
      },
    ],
  }
}

export function SnapchatGiftcardAddToCart(data: IGiftcardTrackingData): any {
  return {
    price: data.total_value,
    currency: data.currency,
    item_ids: [data.trip_id],
    item_category: data.category,
  }
}
